<app-admission-reception-wizard-control-component></app-admission-reception-wizard-control-component>
